import React from 'react';
import { branch } from 'baobab-react/higher-order';

const Loader = ({ loading }) => {
	const loader = (
		<div className="loading">
			Loading...
		</div>
	);
	return loading ? loader : null;
};

export default branch({
	loading: ['loading']
}, Loader);


// WEBPACK FOOTER //
// ./src/pages/components/Loader.js